import { nui } from 'lib/nodes-ui';
import { IMAGE_SIZES, ALLOWED_IMAGE_FILE_TYPES } from 'lib/constants.js';

class FileAttachmentsUI {
  setCanvas(canvas) {
    this.canvas = canvas;
  }

  getImageSize(nodeId) {
    const node = this.canvas.store.getNode(nodeId);
    const maxOriginalDimension = this.getMaxOriginalDimension(nodeId);
    if (node && node.attachedFile && node.attachedFile.display_properties && node.attachedFile.display_properties.size) {
      return node.attachedFile.display_properties.size;
    } else if (node && node.attachedFile && node.attachedFile.display_properties && !node.attachedFile.display_properties.size && node.attachedFile.display_properties.width && node.attachedFile.display_properties.height) {
      return 'custom';
    } else if (node && maxOriginalDimension && maxOriginalDimension <= IMAGE_SIZES.small) {
      return 'small';
    } else {
      return 'medium';
    }
  }

  getMaxOriginalDimension(nodeId) {
    const node = this.canvas.store.getNode(nodeId);
    if (!node || !node.attachedFile) {

      return 0;
    }
    const originalWidth = node.attachedFile.file_attributes.width;
    const originalHeight = node.attachedFile.file_attributes.height;
    const maxDimension = Math.max(originalHeight, originalWidth);
    return maxDimension;
  }

  getImageDimensions(nodeId,size) {
    const node = this.canvas.store.getNode(nodeId);
    let MAX_SIZE = IMAGE_SIZES.medium; // for backwards compatibility
    let MIN_SIZE = IMAGE_SIZES.small;

    if (node.attachedFile && node.attachedFile.display_properties) {

      if (node.attachedFile.display_properties.width && node.attachedFile.display_properties.height) {
        const {width,height} = node.attachedFile.display_properties;
        return {width,height};
      }

      if (node.attachedFile.display_properties.size) {
        const size = size || node.attachedFile.display_properties.size;

        if (size === 'small') {
          MAX_SIZE = IMAGE_SIZES.small;
        } else if (size === 'medium') {
          MAX_SIZE = IMAGE_SIZES.medium;
        } else if (size === 'large') {
          MAX_SIZE = IMAGE_SIZES.large;
        }
      }
    }

    if (node.attachedFile && node.attachedFile.file_attributes && node.attachedFile.file_attributes.width) {
      const originalWidth = node.attachedFile.file_attributes.width;
      const originalHeight = node.attachedFile.file_attributes.height;
      const ratio = originalHeight / originalWidth ;
      const maxDimension = Math.max(originalHeight, originalWidth);
      let width, height;
      if (maxDimension > MAX_SIZE) {
        if (originalWidth > originalHeight) {
          width = MAX_SIZE;
          height = MAX_SIZE * ratio;
        } else {
          height = MAX_SIZE;
          width = MAX_SIZE / ratio;
        }
      } else {
        width = originalWidth;
        height = originalHeight;
      }
      return { width, height };
    }
    return null;
  }

  removeAttachedFile(nodeId) {
    this.canvas.store.getNode(nodeId).updateNode({ attachedFile: null });
    const nodeTag = this.canvas.nodeTags[nodeId];
    if (nodeTag) {
      nodeTag.updateLayers();
      nodeTag.updateTopLevelNeighborsLite();
    }
  }

  getFileUrl(nodeId) {
    const node = this.canvas.store.getNode(nodeId);
    const attachedFile = node.attachedFile;
    return decodeURIComponent(attachedFile.file_url);
  }

  removeImage(nodeId) {
    const node = this.canvas.store.getNode(nodeId);
    if (node.cardless) {
      this.canvas.deleteNode(nodeId);
    } else {
      const attachedFile = node.attachedFile;
      this.canvas.operation.deleteNodeFile({
        nodeUUID: nodeId,
        fileUUID: node.attachedFile.uuid,
        fileUrl: attachedFile.file_url,
        fileType: attachedFile.file_type,
        fileSize: attachedFile.file_size,
        fileAttributes: attachedFile.file_attributes,
        name: attachedFile.name,
        displayProperties: attachedFile.display_properties,
        previewFileUrl: attachedFile.preview_url,
        onSuccess: () => {
          this.removeAttachedFile(nodeId);
        },
        onFailure: err => console.log(err),
      });
    }
  }

  changeImageSize({nodeId,size}) {
    if (size == 'medium' && this.getMaxOriginalDimension(nodeId) <= IMAGE_SIZES.small) {
      return;
    } else if (size == 'large' && this.getMaxOriginalDimension(nodeId) <= IMAGE_SIZES.medium) {
      return;
    }
    const node = this.canvas.store.getNode(nodeId);
    const nodeTag = this.canvas.nodeTags[nodeId];
    const updateNode = () => {
      node.updateNode({ attachedFile: Object.assign({}, node.attachedFile, { display_properties: {size} }) });
      nodeTag.updateImageStyle();
      nodeTag.updateTopLevelNeighborsLite();
      this.canvas.imageSizeMenu.update();
      const { prevNodePositions, nodePositions } = nui.fixOverlaps({
        nodeTag,
        allowedDirections: ['right','down'],
      });
      if (nodePositions.length) {
        this.canvas.operation.updateNodePositions({
          prevNodePositions,
          nodePositions,
          prevLinkAngles: [],
          linkAngles: [],
        });
      }
    };

    let prevDisplayProperties;
    if (node.attachedFile.display_properties && node.attachedFile.display_properties.size) {
      prevDisplayProperties = Object.assign({},node.attachedFile.display_properties);
    } else {
      prevDisplayProperties = { size: 'medium' };
    }
    this.canvas.operation.updateNodeFile({
      nodeUUID: nodeId,
      fileUUID: node.attachedFile.uuid,
      prevDisplayProperties,
      displayProperties: { size },
      onSuccess: updateNode,
      onFailure: err => console.log(err),
    });
  }

  hasImageAttachment(nodeId) {
    if (ALLOWED_IMAGE_FILE_TYPES.includes(store.getNode(nodeId).attachedFile.file_type)) {
      return true;
    }
    return false;
  }
}

const fui = new FileAttachmentsUI();

export { FileAttachmentsUI, fui};



// WEBPACK FOOTER //
// ./starling/src/lib/file-attachments-ui.js